import dayjs from "../../../utils/dayjs";
import {
  daysJsFormat,
  languagesList,
  renderBeneficiary,
  renderStatusLabels,
  renderTypePrestation,
  renderUserName,
} from "../../../utils/constants";
import { Excel } from "antd-table-saveas-excel";
import { Tag } from "antd";
import React from "react";
import { renderPrestationMajoreeTime } from "../../Prestations/PrestationsList/Prestations.list.constants";
import { typesPrestation } from "../../../utils/typesPrestation";

export const BillsExportsExcel = async (prestations, showMin = false) => {
  const exportColumns = [
    {
      title: "Numéro prestation",
      dataIndex: "prestationRef",
    },
    {
      title: "Numéro facture",
      dataIndex: "bill_number",
    },
    {
      title: "Référence",
      dataIndex: "reference",
    },
    {
      title: "Domaine principale",
      dataIndex: "mainCategory",
    },
    {
      title: "Catégorie",
      dataIndex: "category",
    },
    {
      title: "Status de la prestation",
      dataIndex: "status",
    },
    {
      title: "Bénéficiaire",
      dataIndex: "beneficiary",
    },
    {
      title: "Interprète",
      dataIndex: "interprete",
    },
    {
      title: "Genre (de l’interprète)",
      dataIndex: "genre",
    },
    {
      title: "Id Interprète",
      dataIndex: "interpreteId",
    },
    {
      title: "Langue",
      dataIndex: "langue",
    },
    {
      title: "Total Hors TVA",
      dataIndex: "totalHorsTva",
    },
    {
      title: "Cout de la prestation (par tranches)",
      dataIndex: "coutPrestation",
    },
    {
      title: "Tranches de la prestation",
      dataIndex: "tranchesPrestation",
    },
    {
      title: "Tranches de la prestation de nuit",
      dataIndex: "tranchesPrestationNight",
    },
    {
      title: "Cout de nuit de la prestation (par tranches)",
      dataIndex: "coutNight",
    },
    {
      title: "Cout de déplacement",
      dataIndex: "coutTravel",
    },
    {
      title: "Kms",
      dataIndex: "kms",
    },
    {
      title: "Total TTC",
      dataIndex: "totalTTC",
    },
    {
      title: "TVA",
      dataIndex: "tvaAmount",
    },

    {
      title: "Cents correction",
      dataIndex: "ctsCorrection",
    },
    {
      title: "Date de début",
      dataIndex: "startDate",
    },
    {
      title: "Heure de début",
      dataIndex: "startH",
    },
    {
      title: "Date de fin",
      dataIndex: "endDate",
    },
    {
      title: "Heure de fin",
      dataIndex: "endH",
    },
    {
      title: "Durée effective (majorée)",
      dataIndex: "effectiveTime",
      key: "effectiveTime",
    },
    {
      title: "Lieu de départ",
      dataIndex: "locationFrom",
    },
    {
      title: "Lieu de l'intervention",
      dataIndex: "location",
    },
    {
      title: "Type de prestation",
      dataIndex: "typePrestation",
    },
    {
      title: "Institution",
      dataIndex: "institution",
    },
    {
      title: "Hors Canton",
      dataIndex: "horsCanton",
    },
    {
      title: "Urgent",
      dataIndex: "urgent",
    },
  ];

  const findPresta = (arr, key) => {
    return arr.find(e => e.type === key);
  };

  const mutateData = () => {
    let newArr = [];

    prestations.map(presta => {
      const { bill } = presta;
      let amounts = {
        totalHorsTva: 0,
        totalTTC: 0,
        tvaAmount: 0,
        totalNonAssujeti: 0,
        kms: 0,
        ctsCorrection: 0,
        horsCanton: false,
        urgent: false,
        coutPrestation: 0,
        coutNight: 0,
        coutTravel: 0,
        effectiveTime: "",
      };
      if (bill !== null && bill.costParams !== undefined) {
        const { costParams, costs } = bill;

        amounts.effectiveTime = renderPrestationMajoreeTime(presta, showMin);

        if (bill.type === "multiple") {
          let ref = bill.costsMultiple.find(e => e.prestationId === presta._id);

          if (ref !== undefined) {
            amounts.tvaAmount = costParams.tvaAmount;
            amounts.totalHorsTva = costParams.totalHorsTva;
            amounts.totalTTC = costParams.totalWithTva;

            amounts.totalHorsTva = ref.costParams.total;
            // amounts.kms = metersToKilometers(
            //   ref?.costParams?.driving?.distance?.value || 0,
            // );

            let kms = ref.cost.find(p => p.type === "travel")?.tranches || 0;

            amounts.kms = kms;

            amounts.horsCanton = ref.costParams.isHorsCanton;
            amounts.urgent = ref.costParams.isUrgent;
            amounts.coutPrestation =
              findPresta(ref.cost, "prestation")?.amount || 0;
            amounts.coutNight = findPresta(ref.cost, "night")?.amount || 0;
            amounts.coutTravel = findPresta(ref.cost, "travel")?.amount || 0;
            amounts.tranchesPrestation =
              findPresta(ref.cost, "prestation")?.tranches || 0;
            amounts.tranchesPrestationNight =
              findPresta(ref.cost, "night")?.tranches || 0;
          }
        } else {
          amounts.totalHorsTva = costParams.total;
          amounts.totalTTC = costParams.totalWithTva;
          amounts.tvaAmount = costParams.tvaAmount;
          // amounts.totalNonAssujeti = costParams.;
          // amounts.kms = metersToKilometers(
          //   costParams?.driving?.distance?.value || 0,
          // );

          let kms = costs.find(e => e.type === "travel")?.tranches || 0;

          amounts.kms = kms;

          amounts.ctsCorrection = costParams.roundCorrection;
          amounts.horsCanton = costParams.isHorsCanton;
          amounts.urgent = costParams.isUrgent;
          amounts.coutPrestation = findPresta(costs, "prestation")?.amount || 0;
          amounts.coutNight = findPresta(costs, "night")?.amount || 0;
          amounts.coutTravel = findPresta(costs, "travel")?.amount || 0;
          amounts.tranchesPrestation =
            findPresta(costs, "prestation")?.tranches || 0;
          amounts.tranchesPrestationNight =
            findPresta(costs, "night")?.tranches || 0;
        }
      }

      let dates = {
        startDate: null,
        endDate: null,
        startH: null,
        endH: null,
      };

      let locations = {
        location: "",
        locationFrom: "",
      };

      if (
        presta.interventionFinal.startDate !== null &&
        presta.interventionFinal.endDate !== null
      ) {
        dates.startDate = dayjs(presta.interventionFinal.startDate).format(
          daysJsFormat.day,
        );
        dates.endDate = dayjs(presta.interventionFinal.endDate).format(
          daysJsFormat.day,
        );

        dates.startH = dayjs(presta.interventionFinal.startDate).format(
          daysJsFormat.hour,
        );
        dates.endH = dayjs(presta.interventionFinal.endDate).format(
          daysJsFormat.hour,
        );
      } else {
        dates.startDate = dayjs(presta.intervention.startDate).format(
          daysJsFormat.day,
        );
        dates.endDate = dayjs(presta.intervention.endDate).format(
          daysJsFormat.day,
        );

        dates.startH = dayjs(presta.intervention.startDate).format(
          daysJsFormat.hour,
        );
        dates.endH = dayjs(presta.intervention.endDate).format(
          daysJsFormat.hour,
        );
      }

      if (
        presta.interventionFinal.location !== null &&
        presta.interventionFinal.location !== ""
      ) {
        locations.location = presta.interventionFinal.location;
      } else {
        locations.location = presta.intervention.location;
      }

      if (
        presta.interventionFinal.locationFrom !== null &&
        presta.interventionFinal.locationFrom !== ""
      ) {
        locations.locationFrom = presta.interventionFinal.locationFrom;
      } else {
        locations.locationFrom = presta.intervention.locationFrom;
      }

      const mainArray = [];
      const subArray = presta.category || [];

      subArray
        .filter(e => e !== null)
        .forEach(item => {
          let main = typesPrestation.find(e =>
            e.options.find(o => o.value === item),
          )?.label;

          if (!mainArray.includes(main)) {
            mainArray.push(main);
          }
        });

      newArr.push({
        beneficiary: renderBeneficiary(presta.beneficiary),
        genre: presta?.interprete?.info?.genre === "female" ? "Femme" : "Homme",
        mainCategory: mainArray.map(e => e).join(", "),
        category: subArray.map(e => e).join(", "),
        langue: presta.language
          .map(p => languagesList.find(e => e.value === p)?.label)
          .join(" "),
        institution: bill?.institution?.name,
        status: renderStatusLabels(
          presta.status,
          presta.subStatus,
          presta.isFollow,
        ),
        typePrestation: renderTypePrestation(presta.intervention.type),
        reference: bill?.reference,
        bill_number: bill?.bill_number,
        prestationRef: presta.reference,
        interprete: renderUserName(presta?.interprete),
        interpreteId: presta?.interprete?._id,
        ...amounts,
        ...dates,
        horsCanton: amounts.horsCanton ? "Oui" : "Non",
        urgent: amounts.urgent ? "Oui" : "Non",
        ...locations,
      });
    });

    return newArr;
  };

  const excel = new Excel();
  excel
    .addSheet("Facturation")
    .addColumns(exportColumns)
    .addDataSource(mutateData())
    .saveAs("facturation.xlsx");
  return true;
};
